// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Currency from "../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as ReactModal from "react-modal";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CouponsListSM from "../../../app/state-machine/CouponsListSM.bs.js";
import * as Icon$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/icons/Icon.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Button$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as PlaceOrderContext from "../../context/PlaceOrderContext.bs.js";
import * as PlaceOrderGaConfig from "../../../app/helper/PlaceOrderGaConfig.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as PlaceOrderDataMachine from "../../../app/data-machine/PlaceOrderDataMachine.bs.js";
import * as PlaceOrderAssetsManager from "../../assets/PlaceOrderAssetsManager.bs.js";
import * as PlaceOrderCouponPayload from "../../../app/api-model/PlaceOrderCouponPayload.bs.js";
import * as VehicleQuotationPayload from "../../../app/api-model/VehicleQuotationPayload.bs.js";
import * as UnRestrictedVehiclesVmMapper from "../../vm-mapper/UnRestrictedVehiclesVmMapper.bs.js";

var discount_image = PlaceOrderAssetsManager.getImage("discount.svg");

var percentage_symbol = PlaceOrderAssetsManager.getImage("percentage_symbol.svg");

function PlaceOrderCouponCmp$CouponsList(Props) {
  var applyCoupon = Props.applyCoupon;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = PlaceOrderContext.useContext(undefined).state;
  var parentOrderId = match$1.parentOrderId;
  var customerInfo = match$1.customerInfo;
  var geo_region = match$1.geo_region;
  var selectedVehicle = match$1.selectedVehicle;
  var dropAddress = match$1.dropAddress;
  var pickupAddress = match$1.pickupAddress;
  var match$2 = React.useState(function () {
        return "";
      });
  var setCoupon = match$2[1];
  var coupon = match$2[0];
  var match$3 = React.useReducer(CouponsListSM.machine, /* Init */0);
  var dispatch = match$3[1];
  var state = match$3[0];
  React.useEffect((function () {
          var match = pickupAddress.latLng;
          var match$1 = dropAddress.latLng;
          if (match !== undefined && match$1 !== undefined) {
            PlaceOrderDataMachine.fetchCouponList(geo_region !== undefined ? String(geo_region.id) : "", match, match$1, customerInfo.customerId, parentOrderId !== undefined ? String(parentOrderId.orderId) : "", country, (function (data) {
                    return Curry._1(dispatch, {
                                TAG: /* FetchCouponsListSuccess */0,
                                _0: data
                              });
                  }), (function (error) {
                    return Curry._1(dispatch, {
                                TAG: /* FetchCouponsListFailed */1,
                                _0: error
                              });
                  }));
          }
          
        }), []);
  var isCouponDisabled = function (vehicle_ids) {
    if (vehicle_ids.some(function (id) {
            return id === selectedVehicle.vehicle_id;
          })) {
      return false;
    } else {
      return true;
    }
  };
  var tmp;
  if (typeof state === "number" || state.TAG !== /* Data */0) {
    tmp = null;
  } else {
    var data = state._0;
    var match$4 = data.length;
    tmp = match$4 !== 0 ? $$Array.map((function (e) {
              return React.createElement("div", {
                          className: "coupon_card"
                        }, React.createElement("div", {
                              className: "coupon_card_header"
                            }, React.createElement("div", {
                                  className: "coupon"
                                }, React.createElement("img", {
                                      src: percentage_symbol
                                    }), React.createElement("p", undefined, e.coupon_code)), React.createElement(Button$Catalyst.make, {
                                  text: "Apply",
                                  cb: (function (param) {
                                      PlaceOrderGaConfig.publishEvent({
                                            category: /* ConfirmOrder */3,
                                            action: "Coupon From List",
                                            label: "1_" + e.coupon_code + "#2_" + customerInfo.mobile,
                                            value: undefined,
                                            nonInteraction: undefined
                                          }, country);
                                      return Curry._2(applyCoupon, e.coupon_code, "apply");
                                    }),
                                  className: "",
                                  disabled: isCouponDisabled(e.vehicle_ids)
                                })), React.createElement("p", {
                              className: "title"
                            }, e.title), React.createElement("p", {
                              className: "desc"
                            }, e.long_description, React.createElement("br", undefined), e.short_description), React.createElement("p", {
                              className: "valid"
                            }, "valid till " + e.validity));
            }), data) : React.createElement("div", undefined, "No Coupon Available");
  }
  return React.createElement("div", {
              className: "coupon-content"
            }, React.createElement("div", {
                  className: "coupon-content_field"
                }, React.createElement("input", {
                      placeholder: "Enter Coupon Code...",
                      value: coupon,
                      onChange: (function (e) {
                          var value = FormHelper$Catalyst.TargetEventWrapper.value(e);
                          return Curry._1(setCoupon, (function (param) {
                                        return value;
                                      }));
                        })
                    }), React.createElement(Button$Catalyst.make, {
                      text: "Apply",
                      cb: (function (param) {
                          if (coupon === "") {
                            return ;
                          }
                          PlaceOrderGaConfig.publishEvent({
                                category: /* ConfirmOrder */3,
                                action: "Coupon From Input",
                                label: "1_" + coupon + "#2_" + customerInfo.mobile,
                                value: undefined,
                                nonInteraction: undefined
                              }, country);
                          return Curry._2(applyCoupon, coupon, "apply");
                        }),
                      className: ""
                    })), React.createElement("div", {
                  className: "coupon-content_select_container"
                }, React.createElement("p", {
                      className: "label"
                    }, "Applicable on Selected Category"), tmp));
}

var CouponsList = {
  make: PlaceOrderCouponCmp$CouponsList
};

function PlaceOrderCouponCmp(Props) {
  var coupon = Props.coupon;
  var match = React.useState(function () {
        return false;
      });
  var setCouponModal = match[1];
  var match$1 = CountryContext.useContext(undefined);
  var country = match$1.country;
  var match$2 = PlaceOrderContext.useContext(undefined);
  var state = match$2.state;
  var vehicles = state.vehicles;
  var restricted_vehicles = state.restricted_vehicles;
  var customerInfo = state.customerInfo;
  var selectedVehicle = state.selectedVehicle;
  var dispatch = match$2.dispatch;
  var symbol = CountryConfig.getSymbol(country);
  var availableVehicleIds = vehicles.vehicle_ids.filter(function (id) {
        var match = restricted_vehicles.find(function (e) {
              return e === id;
            });
        return match === undefined;
      });
  var setVehicleDetails = function (data, vehicles, currentVehicle, coupon_apply_type) {
    var vehicle = UnRestrictedVehiclesVmMapper.getVM(vehicles.on_demand, data).find(function (e) {
          return e.vehicle_id === currentVehicle.vehicle_id;
        });
    if (vehicle !== undefined) {
      PlaceOrderGaConfig.publishEvent({
            category: /* ConfirmOrder */3,
            action: "Net Fare After Coupon",
            label: "1_" + Belt_Option.getWithDefault(coupon, "") + "#2" + Currency.toCurrencyString(vehicle.bill_details.net_fare, symbol) + "#3_" + coupon_apply_type + "#4_" + customerInfo.mobile,
            value: undefined,
            nonInteraction: undefined
          }, country);
      return Curry._1(dispatch, {
                  TAG: /* SetSelectedVehicle */2,
                  _0: vehicle
                });
    }
    
  };
  var handleCoupon = function (code, couponActionType) {
    if (couponActionType === "apply") {
      var payload = PlaceOrderCouponPayload.getData(code, state, availableVehicleIds, selectedVehicle.vehicle_id);
      return PlaceOrderDataMachine.applyCoupon(payload, country, (function (data) {
                    Curry._1(setCouponModal, (function (param) {
                            return false;
                          }));
                    Curry._1(dispatch, {
                          TAG: /* OpenSnackbar */8,
                          snackbar_message: {
                            TAG: /* Success */0,
                            _0: "Coupon Successfuly Applied!"
                          }
                        });
                    return setVehicleDetails(data, vehicles, selectedVehicle, "applycoupon");
                  }), (function (param) {
                    Curry._1(setCouponModal, (function (param) {
                            return false;
                          }));
                    return Curry._1(dispatch, {
                                TAG: /* OpenSnackbar */8,
                                snackbar_message: {
                                  TAG: /* Error */1,
                                  _0: "Invalid Coupon"
                                }
                              });
                  }));
    } else {
      var payload$1 = VehicleQuotationPayload.getData(code, state, availableVehicleIds);
      return PlaceOrderDataMachine.removeCoupon(payload$1, country, (function (data) {
                    Curry._1(setCouponModal, (function (param) {
                            return false;
                          }));
                    Curry._1(dispatch, {
                          TAG: /* OpenSnackbar */8,
                          snackbar_message: {
                            TAG: /* Success */0,
                            _0: "Coupon Successfuly Removed"
                          }
                        });
                    return setVehicleDetails(data, vehicles, selectedVehicle, "removecoupon");
                  }), (function (param) {
                    Curry._1(setCouponModal, (function (param) {
                            return false;
                          }));
                    return Curry._1(dispatch, {
                                TAG: /* OpenSnackbar */8,
                                snackbar_message: {
                                  TAG: /* Error */1,
                                  _0: "Something went wrong!"
                                }
                              });
                  }));
    }
  };
  var tmp;
  if (coupon !== undefined) {
    PlaceOrderGaConfig.publishEvent({
          category: /* ConfirmOrder */3,
          action: "Auto Applied Coupon",
          label: "1_" + coupon + "#2_" + customerInfo.mobile,
          value: undefined,
          nonInteraction: undefined
        }, country);
    var value = selectedVehicle.bill_details.fare_breakup.find(function (e) {
          if (typeof e === "number" || e.TAG !== /* CouponDiscount */3) {
            return false;
          } else {
            return true;
          }
        });
    var tmp$1;
    if (value !== undefined && !(typeof value === "number" || value.TAG !== /* CouponDiscount */3)) {
      var fare_data = value._0;
      PlaceOrderGaConfig.publishEvent({
            category: /* ConfirmOrder */3,
            action: "Net Fare After Coupon",
            label: "1_" + coupon + "#2" + Currency.toCurrencyString(fare_data.value, symbol) + "#3_\"auto-coupon\"#4_" + customerInfo.mobile,
            value: undefined,
            nonInteraction: undefined
          }, country);
      tmp$1 = Currency.toCurrencyString(fare_data.value, symbol);
    } else {
      tmp$1 = "-";
    }
    tmp = React.createElement(React.Fragment, undefined, React.createElement("div", {
              className: "applied_coupon"
            }, React.createElement("img", {
                  src: discount_image
                }), React.createElement("p", undefined, "You saved", React.createElement("span", {
                      className: "green"
                    }, tmp$1), " with “" + coupon + "” 🎉 ", React.createElement("br", undefined), React.createElement("span", {
                      className: "coupun_status"
                    }, "Coupon Applied"), React.createElement("img", undefined))), React.createElement("p", {
              className: "btn",
              onClick: (function (param) {
                  PlaceOrderGaConfig.publishEvent({
                        category: /* ConfirmOrder */3,
                        action: "Remove Coupon",
                        label: "1_" + coupon + "#2_" + customerInfo.mobile,
                        value: undefined,
                        nonInteraction: undefined
                      }, country);
                  return handleCoupon(undefined, "remove");
                })
            }, "Remove"));
  } else {
    tmp = React.createElement(React.Fragment, undefined, React.createElement("p", undefined, "Apply Coupon"), React.createElement("p", {
              className: "btn",
              onClick: (function (param) {
                  return Curry._1(setCouponModal, (function (param) {
                                return true;
                              }));
                })
            }, React.createElement(Icon$Catalyst.NavigateIcon.make, {})));
  }
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "coupon_container"
                }, tmp), React.createElement(ReactModal, {
                  isOpen: match[0],
                  onRequestClose: (function (param) {
                      return Curry._1(setCouponModal, (function (param) {
                                    return false;
                                  }));
                    }),
                  overlayClassName: "place_order_coupon_modal_overlay",
                  className: "coupon_modal",
                  shouldCloseOnOverlayClick: true,
                  children: React.createElement(PlaceOrderCouponCmp$CouponsList, {
                        applyCoupon: handleCoupon
                      })
                }));
}

var make = PlaceOrderCouponCmp;

export {
  discount_image ,
  percentage_symbol ,
  CouponsList ,
  make ,
  
}
/* discount_image Not a pure module */
